import { Stringifiable } from 'query-string';
import { IVersionsObject } from '@engoo/view-model';

export const getVersionParams = (versions: IVersionsObject) => objectKeyQueryParams('versions', versions);

/**
 * The `query-string` module doesn't support stringifying nested objects, so
 * this helper converts an object's keys into an array-like syntax for query params.
 *
 * For example, `objectKeyQueryParams('root', { a: 1, b: 2, c: 3 })` would return:
 *
 * ```
 * {
 *   'root[a]': 1,
 *   'root[b]': 2,
 *   'root[c]': 3,
 * }
 * ```
 *
 * and when this is stringified with `query-string`, it would become `'?root[a]=1&root[b]=2&root[c]=3'`
 */
const objectKeyQueryParams = (objectName: string, obj: { [key: string]: Stringifiable }) => Object.fromEntries(
  Object.entries(obj).map(([key, value]) => [`${objectName}[${key}]`, value]),
);
